/* eslint-disable jsx-a11y/anchor-is-valid */
import PATabs from "component/design-system/tabs/PATabs";
import Panel from "component/design-system/tabs/Panel";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import Link from "next/link";
import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import Slider from "../../../../component/design-system/carousel/Slider";
import PAImage from "../../../../component/design-system/images/PAImage";
import { getModelIconUrl } from "../../../../util/helper/getModelIconUrl";
import { getRelativeImagePath } from "../../../../util/helper/getRelativeImagePath";
import styles from "./tab-group.module.scss";

function TabGroup(props: any) {
  const {
    data, showScrollOnHover, autoplay = true, showArrowOnHover, grayBackground, component = "span",
  } = props;

  const router = useRouter();

  return (
    <div className={styles.TabsContainer}>
      <PATabs titles={data.map((item) => item.displayableMake || item.make)} component={component}>
        {data.map((item: any, index: any) => (
          <Panel key={index + 1} title={item.displayableMake || item.make}>
            <Slider
              tileWidth={160}
              autoplay={autoplay}
              liClass={`${styles.li_class} ${grayBackground ? styles.gray_background : ""}`}
              showScrollOnHover={showScrollOnHover}
              showArrowOnHover={showArrowOnHover}
            >
              {item.models.map((_: any) => {
                const renderitem = (
                  <>

                    <PAImage
                      unoptimized
                      src={_.img ? getRelativeImagePath(`/images/icons${_.img}`)
                        : getModelIconUrl({ make: item.make, model: _.model })}
                      width={_.isMake ? 60 : 120}
                      height={_.isMake ? 60 : 50}
                      alt={_.popular ? `Browse ${_.displayableModel} Parts and Accessories` : `Discover Quality Parts for ${item.make} ${_.model}`}
                      title={_.popular ? `Browse ${_.displayableModel} Parts and Accessories` : `Discover Quality Parts for ${item.make} ${_.model}`}
                    />

                    <div className={styles.styled_text}>

                      <PAText
                        component="span"
                        fontSize={FONT_SIZE[0]}
                        color="black"
                        bold
                        className="m-t-10 m-b-10"
                      >
                        {_.displayableModel || _.model}
                      </PAText>

                      {/* It seems that there is no use of _.category */}
                      <HideIf show={_.category}>
                        <Text size={5} type={TEXT_TYPE.secondary}>{_.category}</Text>
                      </HideIf>
                    </div>
                  </>
                );
                if (_.popular) {
                  return (
                    (
                      <Link
                        key={_.url}
                        href={_.url}
                        title={`Explore Genuine ${_.displayableModel} Parts and Stylish Accessories`}
                      >

                        {renderitem}

                      </Link>
                    )
                  );
                }
                return (
                  <a
                    href={_.url}
                    onClick={(e) => {
                      e.preventDefault();
                      if (e.ctrlKey) {
                        window.open(_.url, "_blank");
                      } else {
                        router.push(_.url)
                          .then(() => window.scrollTo(0, 0));
                      }
                    }}
                    key={_.url}
                    title={`Locate the Perfect Parts for ${item.make} ${_.model}`}
                  >
                    {renderitem}
                  </a>
                );
              })}
            </Slider>
          </Panel>
        ))}
      </PATabs>
    </div>
  );
}

export default TabGroup;
